import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  theme: {
    currentTheme: 'default',
  },
}

// Define the theme slice
const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    setTheme: (state, action) => {
      state.theme = action.payload
    },
  },
})

// Export actions and reducer
export const { setTheme } = themeSlice.actions

export default themeSlice.reducer
